module.exports = __webpack_public_path__ + "static/fazenda_mano_julio_logo-59c36b98a9c7745bbf0bbd001fc10134.png";